import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  salary: "default",
  title: "",
  type: "all"
};


// create slice
const filterSlice = createSlice({
  name: "job",
  initialState,
  reducers: {
    sortedBySalary: (state, action) => {
      state.salary = action.payload;
    },
    searchedByTitle: (state, action) => {
      state.title = action.payload;
    },
    filteredByType: (state, action) => {
      state.type = action.payload;
    },
  }
});

export default filterSlice.reducer;
export const { sortedBySalary, searchedByTitle, filteredByType } = filterSlice.actions;
